import type { CometDSingleton } from '../../cometd/cometd';
import { CHANNELS } from '../../cometd/cometd.constants';
import type { TPlayerData } from '../../lisService/types';
import { spineBus } from '../MessageBus';
import type { TEvent } from '../../cometd/cometd.types';
import { getUmoboardEventConverters } from './eventConverters';
import { cond } from 'lodash-es';
import type { UmoboardPayload } from '@casumo/fabric-fundamentals';
import type { TEventConverterPayloads } from './eventConverters/eventConverter.types';

const subscriptionHandler = (event: TEvent) => {
    const conditions = getUmoboardEventConverters();
    const getPayload = cond<TEvent, TEventConverterPayloads>(conditions);
    const payload = getPayload(event) as UmoboardPayload;
    if (!payload) return;
    spineBus.publish('umoboard', payload);
};

export const subscribeToCometDUmoboardsUpdates = (
    cometd: CometDSingleton | undefined,
    playerData: TPlayerData | undefined,
    sessionId: string | undefined,
    unsubscribe: VoidFunction = () => {}
): VoidFunction => {
    if (!cometd) {
        return unsubscribe;
    } else {
        const options = playerData?.playerId && sessionId ? { sessionId } : {};
        const umoboardsHandlePromise = cometd.subscribe(
            CHANNELS.UMOBOARDS,
            subscriptionHandler,
            options
        );
        return () =>
            umoboardsHandlePromise.then((umoboardsHandle) => cometd.unsubscribe(umoboardsHandle));
    }
};
